import React from 'react';
import { Printer } from 'lucide-react';

/**
 * Separate Print Button Component
 * Uses simple CSS classes defined in styles.css
 */
export default function PrintButton() {

  function handlePrint() {
    window.print();
  };

  return (
    <button onClick={handlePrint} className="btn-print no-print">
      <Printer size={18} />
      <span>Export PDF</span>
    </button>
  );
};